import React from "react";
import { useLocation } from "react-router-dom";
import { scrollToHash } from "../utils/scroll";

export const Header = (props) => {
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "";

  const handleLearnMoreClick = (e) => {
    if (!isHome) return; // let link navigate to /#about
    e.preventDefault();
    window.history.pushState(null, "", "#about");
    scrollToHash("about");
  };

  return (
    <header id="header">
      <div className="intro"
        style={{
          backgroundImage: "url('img/fp.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center 60px",
          height: "100vh",
        }}>
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p style={{ color: "black" }}>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href={isHome ? "#about" : "/#about"}
                  className="btn btn-custom btn-lg page-scroll"
                  onClick={handleLearnMoreClick}
                >
                  Learn More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
